module.exports = __webpack_public_path__ + "static/img/austin-distel-mpN7xjKQ_Ns-unsplash.a86eaa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/austin-distel-mpN7xjKQ_Ns-unsplash.png
// module id = x+55
// module chunks = 1